import { useQuery } from '@apollo/client/react';
import { HubspotSyncConnectionDocument, HubspotSyncFieldMappingsDocument } from './query.gql';
import { parseHubspotConnectionId, parseHubspotExternalId } from './utils';
import { useDocumentMetadata } from '../../../components/DocumentMetadataProvider';
export function useHubspotSyncConfig(options = {}) {
    var _a, _b;
    const { skip = false } = options;
    const { data } = useDocumentMetadata();
    const { composerId, externalId, externalSource } = data.systemData;
    const connectionId = parseHubspotConnectionId(externalSource);
    const hubspotObject = connectionId ? parseHubspotExternalId(externalId) : undefined;
    const connectionQuery = useQuery(HubspotSyncConnectionDocument, {
        skip: skip || !composerId || !connectionId,
        variables: { id: connectionId !== null && connectionId !== void 0 ? connectionId : '' },
    });
    const connection = (_a = connectionQuery.data) === null || _a === void 0 ? void 0 : _a.hubspotIntegrationConnection;
    const authorizedConnectionId = (connection === null || connection === void 0 ? void 0 : connection.isAuthorized) ? connection.id : undefined;
    const mappingsQuery = useQuery(HubspotSyncFieldMappingsDocument, {
        skip: !authorizedConnectionId,
        variables: { connectionId: authorizedConnectionId !== null && authorizedConnectionId !== void 0 ? authorizedConnectionId : '' },
    });
    const fieldMapping = (_b = mappingsQuery.data) === null || _b === void 0 ? void 0 : _b.hubspotIntegrationMetadataFieldMappings.find((mapping) => mapping.objectType === (hubspotObject === null || hubspotObject === void 0 ? void 0 : hubspotObject.objectType) && mapping.templateIds.includes(composerId));
    return {
        loading: connectionQuery.loading || mappingsQuery.loading,
        error: connectionQuery.error || mappingsQuery.error,
        fieldMapping,
        objectId: hubspotObject === null || hubspotObject === void 0 ? void 0 : hubspotObject.objectId,
    };
}
